import request from '@/utils/request';

// 设备报表
export const getDeptCusOrderStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptOrder/order',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportDeptCusOrderStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptOrder/export',
    method: 'get',
    params
  });


  export const getDeptSerOrderStatistics = (params: any) =>
    request({
      url: 'StatisticsDeptSerOrder/order',
      method: 'get',
      params
    });
  
  // 导出excel 设备列表
  export const exportDeptSerOrderStatistics = (params: any) =>
    request({
      url: 'StatisticsDeptSerOrder/export',
      method: 'get',
      params
    });
  

  // 服务部门工时趋势
  export const getDeptSerOrderWorkTimeTrend = (params: any) =>
    request({
      url: 'StatisticsDeptSerOrderWorkTime/trend',
      method: 'get',
      params
    });
